import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { Helmet } from "react-helmet";
import mixpanel from "../lib/mixPanel";

import metaTags from "../../config/meta.json";
import getHeaderData from "../lib/getHeaderData";
import Api from "../lib/componentApi";
import Banner from "../components/Common/Banner";

export const GlobalContext = React.createContext();

export const GlobalConsumer = GlobalContext.Consumer;

class GlobalProvider extends Component {
  constructor(props) {
    super(props);
    const { basketData, allAmount, user } = this.getBasket();

    this.state = {
      basketData,
      allAmount,
      user,
      updateBasket: (updatedBasket, shouldUpdate) =>
        this.updateBasket(updatedBasket, shouldUpdate),
      updateUser: ({ shouldUpdate }) => this.updateUser({ shouldUpdate })
    };
    //eslint-disable-next-line
    if (__isBrowser__) {
      var m = document.getElementsByTagName("meta");
      if (m && m.length) {
        for (var c = 0; c < m.length; c++) {
          if (m[c].name == "apple-itunes-app") {
            m[c].content = "";
            m[c].name = "";
          }
        }
      }
    }
  }
  componentDidMount() {
    this.forceUpdate();
  }

  getBasket = () => {
    const staticContext = this.props.staticContext;
    const { initialData, userBasketData } = getHeaderData(
      staticContext,
      "user"
    );

    let basketData = userBasketData;
    let allAmount = 0;

    if (basketData) {
      if (basketData && basketData.restaurant && basketData.restaurant.name) {
        mixpanel.people.set({
          "Basket Restaurant": basketData.restaurant.name
        });
      }
      allAmount = this.calculateAllAmount(basketData);
    }
    let user = null;
    if (initialData) {
      user = initialData;
      if (user && user.uid) {
        const { pointsExpires } = user || [];
        const lastPointsExpires = pointsExpires[pointsExpires.length - 1];
        mixpanel.people.set({
          $email: user.email,
          $name: `${user.firstName} ${user.lastName}`,
          $phone: user.mobileNumber,
          "eCoins Expire Date":
            (lastPointsExpires && lastPointsExpires.expiresAt) || "-",
          "eCoins Expire": (lastPointsExpires && lastPointsExpires.points) || 0
        });
      }
    }

    return {
      allAmount,
      basketData,
      user
    };
  };
  getBasketApi = () => {
    let basketData = null;
    Api.get("/api/product/basket", {}, (response, errors) => {
      if (errors) {
        if (errors === 503) {
          this.setState(() => {
            throw errors;
          });
        } else {
          console.log(errors);
        }
      } else {
        basketData = response;
        this.basketCallback(basketData);
      }
    });
  };
  basketCallback = basketData => {
    let allAmount = this.calculateAllAmount(basketData);
    this.setState({
      basketData,
      allAmount
    });
  };
  calculateAllAmount = data => {
    let allAmount = 0;
    if (data && data.items) {
      mixpanel.people.set({ "Basket is empty": false, Platform: "Web" });
      if (data.subTotal) {
        allAmount = data.subTotal;
      } else {
        allAmount = data.items.reduce(
          (first, next) => parseFloat(first) + parseFloat(next.totalAmount),
          0
        );
      }
    } else {
      mixpanel.people.set({ "Basket is empty": true, Platform: "Web" });
    }
    return (allAmount && parseFloat(allAmount).toFixed(2)) || 0;
  };
  updateBasket = (updatedBasket, shouldUpdate) => {
    if (shouldUpdate) {
      this.getBasketApi();
    } else {
      if (updatedBasket) {
        this.setState({ basketData: updatedBasket }, () => {
          const allAmount = this.calculateAllAmount(this.state.basketData);
          this.setState({
            allAmount
          });
        });
      }
    }
  };
  updateUser = ({ shouldUpdate }) => {
    Api.get("/api/profile", {}, (response, errors) => {
      if (errors) {
        if (errors === 503) {
          this.setState(() => {
            throw errors;
          });
        } else {
          console.log(errors);
        }
      } else if (response.code) {
        console.log(response, "code-global-context");
      } else {
        this.setState(
          {
            user: response
          },
          () => {
            if (response.uid) {
              const { pointsExpires } = response || [];
              const lastPointsExpires = pointsExpires[pointsExpires.length - 1];
              mixpanel.people.set({
                $email: response.email,
                $name: `${response.firstName} ${response.lastName}`,
                $phone: response.mobileNumber,
                "eCoins Expire Date":
                  (lastPointsExpires && lastPointsExpires.expiresAt) || "-",
                "eCoins Expire":
                  (lastPointsExpires && lastPointsExpires.points) || 0
              });
            }
            if (shouldUpdate) {
              this.getBasketApi();
            }
          }
        );
      }
    });
  };
  render() {
    const { pathname } = this.props.location;
    const dynamicTitle =
      "%s - " + ((metaTags && metaTags.title && metaTags.title) || "Locale");
    return (
      <GlobalContext.Provider value={this.state}>
        <Helmet
          defaultTitle={
            (metaTags && metaTags.title && metaTags.title) || "Locale"
          }
          titleTemplate={dynamicTitle}
        >
          <meta
            property="og:title"
            content={(metaTags && metaTags.title && metaTags.title) || "Locale"}
          />
        </Helmet>
        <Banner route={pathname} />
        {this.props.children}
      </GlobalContext.Provider>
    );
  }
}
export default withRouter(GlobalProvider);
